<div class="grid grid-cols-3 items-center py-4 px-2 text-grey-mid">
  <div class="flex items-start text-sm">
    <span class="italic md:hidden">Per Page</span>
    <span class="italic hidden md:block">Items Per Page</span>
    <ion-select
      class="py-0 w-14 pl-2 bottom-2.5 text-sm text-primary font-semibold"
      interface="popover"
      [(ngModel)]="perPage"
      (ionChange)="changePerPage($event)"
    >
      <ion-select-option value="25">25</ion-select-option>
      <ion-select-option value="50">50</ion-select-option>
      <ion-select-option value="75">75</ion-select-option>
      <ion-select-option value="100">100</ion-select-option>
      <ion-select-option value="250">250</ion-select-option>
    </ion-select>
  </div>
  <div class="flex flex-col items-center">
    @if (pageButtonArray.length >= 1) {
      <div class="flex justify-center mb-1">
        <a
          [ngClass]="{ 'pointer-events-none text-secondary': paginationState?.page === 1 }"
          class="flex items-center px-2 py-1 mx-1 text-lg rounded-md hover:bg-grey-concrete"
          (click)="previousPage()"
        >
          <ion-icon name="chevron-back-outline"></ion-icon>
        </a>
        <a
          class="px-3 py-1 mx-1 text-sm rounded-md hover:bg-grey-concrete hidden md:block"
          [ngClass]="{ 'bg-primary text-white hover:bg-primary': paginationState?.page === 1 }"
          (click)="selectPage(1)"
        >
          1
        </a>
        <a class="px-3 py-1 mx-1 text-sm rounded-md bg-primary text-white md:hidden">
          {{ paginationState?.page }}
        </a>
        @if (paginationState?.page >= maxPages) {
          <a class="px-3 py-1 mx-1 text-sm rounded-md text-secondary pointer-events-none hidden md:block"> ... </a>
        }
        @for (pageButton of pageButtonArray; track pageButton) {
          <a
            class="px-3 py-1 mx-1 text-sm rounded-md hover:bg-grey-concrete hidden md:block"
            [ngClass]="{ 'bg-primary text-white hover:bg-primary': paginationState?.page === pageButton }"
            (click)="selectPage(pageButton)"
            >{{ pageButton }}</a
          >
        }
        @if (paginationState?.total_pages - maxPages + 1 > paginationState?.page) {
          <a class="px-3 py-1 mx-1 text-sm rounded-md text-secondary pointer-events-none hidden md:block"> ... </a>
        }
        @if (!pageButtonArray.includes(paginationState?.total_pages)) {
          <a
            class="px-3 py-1 mx-1 text-sm rounded-md hover:bg-grey-concrete hidden md:block"
            [ngClass]="{
              'bg-primary text-white hover:bg-primary': paginationState?.page === paginationState?.total_pages,
            }"
            (click)="selectPage(paginationState?.total_pages)"
          >
            {{ paginationState?.total_pages }}
          </a>
        }
        <a
          [ngClass]="{ 'pointer-events-none text-secondary': paginationState?.page === paginationState?.total_pages }"
          class="flex items-center px-2 py-1 mx-1 text-lg rounded-md hover:bg-grey-concrete"
          (click)="nextPage()"
        >
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </a>
      </div>
    }
    @if (paginationState?.total_records > paginationState?.per_page) {
      <small class="text-center">
        Displaying {{ (paginationState?.page - 1) * paginationState?.per_page + 1 }} to
        {{
          paginationState?.page === paginationState?.total_pages
            ? paginationState?.total_records
            : paginationState?.per_page * paginationState?.page
        }}
        of {{ paginationState?.total_records }}
      </small>
    } @else {
      <small class="text-center">
        Displaying {{ paginationState?.total_records }} record{{ paginationState?.total_records > 1 ? 's' : '' }}
      </small>
    }
  </div>
  <div class="flex flex-col items-end">
    <ng-content></ng-content>
  </div>
</div>
